import { GlobalScoreLayout } from '../../shared/global-score-layout/global-score-layout';
import { ScoreCard } from '../../shared/score-card/score-card';
import { ScoreDetailsTable } from '../../shared/score-details-table/score-details-table';

export interface RaceResult {
    time: number;
    completed: boolean;
    treeHits: number;
}

export function calculateRaceScore(timeMs: number, completed: boolean): number {
    if (!completed) {
        return 0;
    }

    const timeSeconds = timeMs / 1000;
    const baseScore = 10000;
    const targetTime = 60;

    if (timeSeconds <= targetTime) {
        // Bonus for times under 60s: exponentially increasing
        const secondsSaved = targetTime - timeSeconds;
        const bonus = Math.pow(secondsSaved, 1.5) * 200;
        return Math.round(baseScore + bonus);
    }

    // Score decreases progressively for slower times
    const penalty = Math.pow((timeSeconds - targetTime) / 10, 1.5) * 500;
    return Math.max(0, Math.round(baseScore - penalty));
}

function formatTime(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const centiseconds = Math.floor((ms % 1000) / 10);
    return `${minutes}:${seconds.toString().padStart(2, '0')}.${centiseconds.toString().padStart(2, '0')}`;
}

export const GlobalScoreComponent: React.FC<{
    races: RaceResult[]
}> = ({ races }) => {
    const totalScore = races.reduce((sum, race) =>
        sum + calculateRaceScore(race.time, race.completed), 0);

    return (
        <GlobalScoreLayout totalScore={Math.round(totalScore)}>
            {races.map((race, index) => (
                <ScoreCard
                    key={index}
                    name="Descente"
                    score={calculateRaceScore(race.time, race.completed)}
                >
                    <ScoreDetailsTable rows={[
                        { label: 'Temps:', value: formatTime(race.time) },
                    ]} />
                </ScoreCard>
            ))}
        </GlobalScoreLayout>
    );
};
